import { ModalPopup, PrimaryButton, SofturaTable } from "client/CommonComponents";
import { FilteringMode } from 'ka-table/enums';
import ExceptionErrorLogsPopup from "./ExceptionErrorLogsPopup";

const ExceptionErrorLogs = (props: any) => {
    const {
        errorLogsData,
        errorLogsColumn,
        totalItem,
        pagesCount,
        hideShowErrorPopup,
        exceptionErrorLogDetails,
        handleFilterClear,
        fetchAction
    } = props
    return (
        <>

            <PrimaryButton text='Clear Filters' onClick={handleFilterClear} className='filter-btn ms-2'  data-attribute="ExceptionErrorLogs_Default_Button" />
            <div className={`${errorLogsData?.length != 0 ? "softura-table" : "softura-table paginationNav"
        }`}>
                <SofturaTable
                    data={errorLogsData ?? []}
                    columns={errorLogsColumn}
                    sort={true}
                    defaultPageSize={10}
                    pageSizes={[10, 20, 50]}
                    filter={true}
                    filteringMode={FilteringMode.FilterRow}                                        
                    isServerSide={true}
                    serverTotal={totalItem}
                    pagesCount={pagesCount}
                    fetchAction={fetchAction}
                 data-attribute="ExceptionErrorLogs_Default_Grid" />
            </div>

            <div>
                {props.showErrorPopup ?
                    <ModalPopup
                        ShowModalPopupFooter={false}
                        ModalPopupTitle="Exception Error Log"
                        ModalPopupType="medium-large"      
                        closeModalPopup={hideShowErrorPopup}
                     data-attribute="ExceptionErrorLogs_Default_ModalPopup">
                        <ExceptionErrorLogsPopup
                            exceptionErrorLogDetails={exceptionErrorLogDetails}
                        />
                    </ModalPopup>
                    : null}
            </div>

        </>
    )
}

export default ExceptionErrorLogs